<span  class="{{className}}" data-bs-toggle="tooltip" ngbTooltip="{{toolTip}}" placement="{{placement}}"  (click)="onClickEvent($event)">
    <img *ngIf="!loadingIcon && iconSrc" src="{{iconSrc}}" alt=""/>
    <span *ngIf="!loadingIcon && faIcon" >
        <fa-icon [icon]="faIcon"></fa-icon>
    </span>
    <span *ngIf="!loadingIcon && text">
      {{text}}
    </span>
    <div *ngIf="loadingIcon && progress !== undefined" class="circular-loader">
      <svg viewBox="0 0 36 36" class="circular-chart">
        <path class="circle-bg" d="M18 2.0845
               a 15.9155 15.9155 0 0 1 0 31.831
               a 15.9155 15.9155 0 0 1 0 -31.831" />
        <path class="circle" [attr.stroke-dasharray]="progress + ', 100'" d="M18 2.0845
               a 15.9155 15.9155 0 0 1 0 31.831
               a 15.9155 15.9155 0 0 1 0 -31.831" />
      </svg>
      <span class="percentage-text">{{ progress }}%</span>
    </div>
    <fa-icon *ngIf="loadingIcon && progress === undefined" [icon]="faSpinner" [animation]="'spin'"></fa-icon>
</span>
                    